// extracted by mini-css-extract-plugin
export default {"root":"Service_root__nIUuQ","link":"Service_link__4qbdq"};